import React, { createContext, useContext, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);

export function CompareProvider({ children }) {
  const [items, setItems] = useState([]); // array of property objects

  const toggle = (property) => {
    setItems((prev) => {
      if (prev.find((p) => p.id === property.id)) return prev.filter((p) => p.id !== property.id);
      if (prev.length >= 3) { toast.error("You can compare up to 3 properties"); return prev; }
      return [...prev, property];
    });
  };
  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const clear = () => setItems([]);
  const has = (id) => !!items.find((p) => p.id === id);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, has }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
